import { Pipe, PipeTransform } from '@angular/core';
import { nameToHslColor } from '@cf/core';

@Pipe({ name: 'hslColor' })
export class HslColorPipe implements PipeTransform {
  transform(value: string, saturation = 70, lightness = 50, transparancy = 0): string {
    if (!value) {
      return '';
    }
    return nameToHslColor(value, saturation, lightness, transparancy);
  }
}
